module.exports = __webpack_public_path__ + "img/136.586254a8.jpg";